<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="itemFiltre">

        <h6 class="subTitle3 cursorPoint" @mousedown="collaps = !collaps">{{collaps == true ? '-' : '+'}} {{$t('i_Filtres')}}</h6>
            <span v-show="collaps">

            <!--Filtre 1-->
            <s-subElementSelector 
                class="grpPrix" 
                saveValue="filterName"
                :apiAdd1="apiURLItemFilter" 
                showField="filterName" 
                returnField="id" 
                :content="filtreList"
                :returnAddValue.sync="filtreList"
                name= "Filtre1" 
                addLength="30"
                :title="$t('i_Filtre1')" 
                :value="_Filtre1" 
                :returnValue.sync="_Filtre1" 
                :selectedItems="_Filtre1">
            </s-subElementSelector>

            <!--Filtre 2, 3, 4, 5, 6-->
            <b-button class="btnMode MargeTop5" type="button" :variant="getTheme.warning" @mousedown="collapsSub = !collapsSub"><s-upDownArrow :status="collapsSub"></s-upDownArrow></b-button>
            <span v-show="collapsSub">
                <b-row><b-button class="btnMode MargeLeft15 MargeTop5" type="button" @click="copieFiltre()">{{$t('i_Copie')}}</b-button></b-row>

                <!--Filtre 2-->
                <s-subElementSelector 
                    class="grpPrix" 
                    saveValue="filterName"
                    :apiAdd1="apiURLItemFilter" 
                    showField="filterName" 
                    returnField="id" 
                    :content="filtreList"
                    :returnAddValue.sync="filtreList"
                    name= "Filtre2" 
                    addLength="30"
                    :title="$t('i_Filtre2')" 
                    :value="_Filtre2" 
                    :returnValue.sync="_Filtre2" 
                    :selectedItems="_Filtre2">
                </s-subElementSelector>

                <!--Filtre 3-->
                <s-subElementSelector 
                    class="grpPrix" 
                    saveValue="filterName"
                    :apiAdd1="apiURLItemFilter" 
                    showField="filterName" 
                    returnField="id" 
                    :content="filtreList"
                    :returnAddValue.sync="filtreList"
                    name= "Filtre3" 
                    addLength="30"
                    :title="$t('i_Filtre3')" 
                    :value="_Filtre3" 
                    :returnValue.sync="_Filtre3" 
                    :selectedItems="_Filtre3">
                </s-subElementSelector>

                <!--Filtre 4-->
                <s-subElementSelector 
                    class="grpPrix" 
                    saveValue="filterName"
                    :apiAdd1="apiURLItemFilter" 
                    showField="filterName" 
                    returnField="id" 
                    :content="filtreList"
                    :returnAddValue.sync="filtreList"
                    name= "Filtre4" 
                    addLength="30"
                    :title="$t('i_Filtre4')" 
                    :value="_Filtre4" 
                    :returnValue.sync="_Filtre4" 
                    :selectedItems="_Filtre4">
                </s-subElementSelector>

                <!--Filtre 5-->
                <s-subElementSelector 
                    class="grpPrix" 
                    saveValue="filterName"
                    :apiAdd1="apiURLItemFilter" 
                    showField="filterName" 
                    returnField="id" 
                    :content="filtreList"
                    :returnAddValue.sync="filtreList"
                    name= "Filtre5" 
                    addLength="30"
                    :title="$t('i_Filtre5')" 
                    :value="_Filtre5" 
                    :returnValue.sync="_Filtre5" 
                    :selectedItems="_Filtre5">
                </s-subElementSelector>

                <!--Filtre 6-->
                <s-subElementSelector 
                    class="grpPrix" 
                    saveValue="filterName"
                    :apiAdd1="apiURLItemFilter" 
                    showField="filterName" 
                    returnField="id" 
                    :content="filtreList"
                    :returnAddValue.sync="filtreList"
                    name= "Filtre6" 
                    addLength="30"
                    :title="$t('i_Filtre6')" 
                    :value="_Filtre6" 
                    :returnValue.sync="_Filtre6" 
                    :selectedItems="_Filtre6">
                </s-subElementSelector>

            </span>
        </span>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/store'

export default{
    name: 'itemFiltre',
    components: {

},
    props: ['Filtre1', 'Filtre2', 'Filtre3', 
            'Filtre4', 'Filtre5', 'Filtre6'],
    data() {
        return {
            collaps: false,
            collapsSub: false,
            apiURLItemFilter : this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiItemFilter
        }
    },
    methods: {
        copieFiltre(){
            this._Filtre2 = this._Filtre1
            this._Filtre3 = this._Filtre1
            this._Filtre4 = this._Filtre1
            this._Filtre5 = this._Filtre1
            this._Filtre6 = this._Filtre1
        }
    },
    computed: {
        ...mapGetters(['getTheme', 'getApiAdress','getInventory']),
        _Filtre1: {
            get: function() {return this.Filtre1},
            set: function(modifiedValue){this.$emit('update:Filtre1', modifiedValue)}
        },
        _Filtre2: {
            get: function() {return this.Filtre2},
            set: function(modifiedValue){this.$emit('update:Filtre2', modifiedValue)}
        },
        _Filtre3: {
            get: function() {return this.Filtre3},
            set: function(modifiedValue){this.$emit('update:Filtre3', modifiedValue)}
        },
        _Filtre4: {
            get: function() {return this.Filtre4},
            set: function(modifiedValue){this.$emit('update:Filtre4', modifiedValue)}
        },
        _Filtre5: {
            get: function() {return this.Filtre5},
            set: function(modifiedValue){this.$emit('update:Filtre5', modifiedValue)}
        },
        _Filtre6: {
            get: function() {return this.Filtre6},
            set: function(modifiedValue){this.$emit('update:Filtre6', modifiedValue)}
        },
        filtreList : () => store.getters.getInventory?.data?.itemFilterList,
    }
}
</script>

<style lang="scss" scoped>

</style>